export default __webpack_public_path__ + "static/media/lobby-1920.c24b5b9c.jpg";